export enum NotificationFrequencyEnum {
  INSTANTLY = 'INSTANTLY',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY'
}
